<div class="user-container-form">
  <div class="header">
    <span>{{ !userToEdit ? "Ajouter un nouvel utilisateur" : "Éditer l'utilisateur " + userToEdit.firstName + ' ' + userToEdit.lastName}}</span>
  </div>
  <div class="form" [formGroup]="form">
    <mat-form-field appearance="outline">
      <mat-label>Identifiant</mat-label>
      <input matInput type="text" formControlName="userName" required>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Nom</mat-label>
      <input matInput type="text" formControlName="lastName">
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Prénom</mat-label>
      <input matInput type="text" formControlName="firstName">
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Email</mat-label>
      <input matInput type="email" formControlName="email">
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Role</mat-label>
      <mat-select formControlName="role" required>
        <mat-option *ngFor="let role of roles" [value]="role">
          {{ role.code }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Code</mat-label>
      <mat-select formControlName="actor">
        <mat-option *ngFor="let actor of actors" [value]="actor">
          {{ actor.code }} - {{ actor.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>

  </div>
  <div class="actions">
    <ng-container *ngIf="!isLoading; else loadingTemplate">
      <button mat-raised-button class="cancel" (click)="cancel()">Annuler</button>
      <button mat-raised-button [disabled]="form.invalid" class="save" (click)="save()">
        <span>{{ !userToEdit ? "Ajouter" : "Sauvegarder"}}</span>
      </button>
    </ng-container>

    <ng-template #loadingTemplate>
      <mat-spinner diameter="50"></mat-spinner>
    </ng-template>
  </div>
</div>
